// Fabrique un `_highlightResult` (balises <mark>) a partir
// de la saisie utilisateur, pour les hits Elasticsearch : les composants
// d'affichage (Highlight, ProductCard, BrandNameLink) surlignent alors les
// termes de la recherche.

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

export const buildHighlightResult = (
  query: string,
  hit: Record<string, any>,
  attributes: string[]
): Record<string, { value: string }> | undefined => {
  const terms = query
    .trim()
    .split(/\s+/)
    .filter(term => term.length >= 2)
    .map(escapeRegExp)
  if (terms.length === 0) return undefined

  const matcher = new RegExp(`(${terms.join('|')})`, 'gi')
  const result: Record<string, { value: string }> = {}
  attributes.forEach(attribute => {
    const raw = hit?.[attribute]
    if (typeof raw !== 'string' || raw === '') return
    result[attribute] = { value: escapeHtml(raw).replace(matcher, '<mark>$1</mark>') }
  })

  return result
}
